<template>
  <ConfirmModal
    ref="modalRef"
    title="Log out of Tallo?"
    description="You'll need to sign in again on this device."
    confirm-label="Log out"
    @confirm="handleLogout"
  />
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { ConfirmModal } from '@tallo/design-system';

import { useAuthStore } from '../auth.store';

const props = defineProps<{
  onLogoutSuccess?: () => void;
}>();

const authStore = useAuthStore();
const modalRef = ref<InstanceType<typeof ConfirmModal>>();

defineExpose({
  show,
});

function show() {
  modalRef.value?.show();
}

function handleLogout() {
  authStore.logout();
  if (props.onLogoutSuccess) {
    props.onLogoutSuccess();
  }
}
</script>
